<template>
  <div id="home" :class="{content: true, noScroll: !canScroll}">
    <div class="getingData" v-if="getingData2"></div>
    <div class="getingData" v-if="getingData"></div>
    <div class="notFound" v-else-if="notFound">
      <div class="nfCnt">
        <img src="../assets/not-found.png">
        <h4>404 - Not Found</h4>
        <p>Maybe content you looking is for deleted or you click wrong button.</p>
      </div>
    </div>
    <div v-else>
      <div class="productVariants" v-if="variant">
        <h4>Variant ({{variant.name}})</h4>
        <div :class="{variantItem: true, active: selectedVariantItem === item}"
          v-on:click="showVaItemOptions = item"
          v-for="(item, i) in variant.items" :key="i">
          {{item.name}} <div class="more" v-on:click.stop="showVaItemOptions = item"></div>
          <div class="vaItemOverlay" v-if="showVaItemOptions && showVaItemOptions === item"
            v-on:click.stop="showVaItemOptions = null"></div>
          <div class="vaItemOptions" v-if="showVaItemOptions && showVaItemOptions === item">
            <li v-on:click.stop="editVariantItem(i, item)">Edit {{item.name}}</li>
            <li v-on:click.stop="deleteVariantItem(i, item)">Delete {{item.name}}</li>
          </div>
        </div>
        <div class="variantItem addVariantItem"
          v-on:click="addVariantItem"><span>+</span> {{variant.name}}</div>
        <div class="variantConfig" v-on:click="showVariantOptions = true"></div>
        <div class="variantOverlay" v-on:click="showVariantOptions = false"
          v-if="showVariantOptions"></div>
        <div class="variantOptions" v-if="showVariantOptions">
          <li v-on:click="editVariant">Edit Product Variant</li>
          <li v-on:click="deleteVariant">Delete Product Variant</li>
        </div>
      </div>
      <div :class="{articleCnt: true, hasVariant: variant}">
        <div class="addVariant" v-on:click="addVariant" v-if="!variant
          && parent && parent.slug === 'products'">
          <span>+</span> Add Product Variant
        </div>
        <textarea class="articleTitle" rows="1" placeholder="Title here..."
          :style="{'height': titleMinHeight}" v-model="form.title.model"
          v-on:input="titleChanged" ref="title" v-on:blur="save('draft')"/>
        <div class="titleError" v-if="form.title.error">Please input title.</div>

        <h4 class="sectionTitle" v-if="parent && parent.slug === 'products'">Product Images</h4>
        <div class="aticlesImages" v-if="parent && parent.bodykey === 0">
          <div class="articleImg" v-for="(img, i) in images" :key="i">
            <div class="theImg" :style="{'background-image': `url(${img.media.imageMd})`}"
              v-if="img.media">
              <div class="imgAction" v-if="img.id">
                <div class="edit" v-on:click="editImg(i, img)"></div>
                <div class="delete" v-on:click="deleteImg(i, img)"></div>
              </div>
            </div>
            <div class="theImg" v-else>
              <div class="imgAction" v-if="img.id">
                <div class="edit" v-on:click="editImg(i, img)"></div>
                <div class="delete" v-on:click="deleteImg(i, img)"></div>
              </div>
            </div>
          </div>
          <div class="articleImg addImg" v-on:click="addImg">
            <div class="addImg">
              <img src="../assets/image-black.png">
              Add Image or Video
            </div>
          </div>
        </div>

        <div class="authorInfo">
          <div :class="{authorImg: true, hasPhoto: $session.get('avatar')}"
            :style="{'background-image': `url('${$session.get('avatar')}')`}">
            <span>{{$session.get('name').substr(0,2)}}</span>
          </div>
          <h4>{{$session.get('name')}}</h4>
          <div class="publishTime">
            <span><i v-on:click="t.dates.active = true">{{pt.getDate()}} </i>
              <div :class="{overlay: true, active: t.dates.active}"
                v-on:click="t.dates.active = false"/>
              <ul :class="{timeSelector: true, active: t.dates.active}">
                <li v-for="(d, index) of t.dates.data" :key="index"
                  v-on:click="selectPT('date', d)">{{d}}</li>
              </ul>
            </span> <span><i v-on:click="t.months.active = true">
              {{t.months.data[pt.getMonth()]}} </i>
              <div :class="{overlay: true, active: t.months.active}"
                v-on:click="t.months.active = false"/>
              <ul :class="{timeSelector: true, active: t.months.active}">
                <li v-for="(mo, index) of t.months.data" :key="index"
                  v-on:click="selectPT('month', index)">{{mo}}</li>
              </ul>
            </span>
            <span><i v-on:click="t.years.active = true">{{pt.getFullYear()}} </i>
              <div :class="{overlay: true, active: t.years.active}"
                v-on:click="t.years.active = false"/>
              <ul :class="{timeSelector: true, active: t.years.active}">
                <li v-for="(y, index) of t.years.data" :key="index"
                  v-on:click="selectPT('year', y)">{{y}}</li>
              </ul>
            </span> at
            <span><i v-on:click="t.hours.active = true">
              {{getHours()}}</i><div
              :class="{overlay: true, active: t.hours.active}"
              v-on:click="t.hours.active = false"/>
              <ul :class="{timeSelector: true, active: t.hours.active}">
                <li v-for="(h, index) of t.hours.data" :key="index"
                  v-on:click="selectPT('hour', h)">{{h}}</li>
              </ul>
            </span>:<span><i v-on:click="t.minutes.active = true">{{getMinutes()}} </i>
              <div :class="{overlay: true, active: t.minutes.active}"
                v-on:click="t.minutes.active = false"/>
              <ul :class="{timeSelector: true, active: t.minutes.active}">
                <li v-for="(m, index) of t.minutes.data" :key="index"
                  v-on:click="selectPT('minute', m)">{{m}}</li>
              </ul>
            </span>
          </div>
        </div>

        <div class="buyButtonCnt" v-if="parent && parent.slug === 'products'">
          <h4 class="sectionTitle">Buy Button Url</h4>
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="Paste url here..."
              v-model="form.buttonUrl.model" v-on:input="buttonUrlChanged">
          </div>
        </div>

        <h4 class="sectionTitle sectionTitleEditor"
          v-if="parent && parent.slug === 'products'">Product Description</h4>
        <Editor ref="editor" v-model="form.content.model" :content="content"
          v-on:input="contentChanged" v-if="editorType === 'default'"/>
        <div class="editorCnt" v-else-if="editorType === 'html'">
          <div class="htmlEditorHeader">HTML Editor</div>
          <PrismEditor v-model="form.content.model" :highlight="highlighter"
            v-on:input="contentChanged"
            class="htmlEditor"></PrismEditor>
          <div class="editorPreview" v-html="form.content.model"
            v-if="editorType === 'withPreview'"></div>
        </div>
      </div>
      <div class="editorCnt withPreview" v-if="editorType === 'withPreview'">
        <div class="editorL">
          <div class="htmlEditorHeader">HTML Editor</div>
          <PrismEditor v-model="form.content.model" :highlight="highlighter"
            v-on:input="contentChanged"
            class="htmlEditor"></PrismEditor>
        </div>
        <div class="editorR">
          <div class="htmlEditorHeader">Preview</div>
          <div class="editorPreview" v-html="form.content.model"
            v-if="editorType === 'withPreview'"></div>
        </div>
      </div>

      <div class="formAction">
        <div class="formActionCnt">
          <div class="categoryCnt">
            <div class="theBtn" v-on:click="openCategorySelector = true">
              Category <img src="../assets/up.png">
              <b v-if="selectedCategory.length > 1">{{selectedCategory.length}} categories</b>
              <b v-else-if="selectedCategory.length > 0">{{selectedCategory[0].name}}</b>
              <b v-else>Uncategorized</b>
            </div>
            <div class="configOverlay" v-if="openCategorySelector"
              v-on:click="openCategorySelector = false"></div>
            <div class="configContent" v-if="openCategorySelector">
              <div class="configItem">
                <h4>Select Category</h4>
                <div :class="{ciItem: true, selected: c.selected}"
                  v-for="(c, index) in categories" :key="index"
                  v-on:click="selectCategory(index, c)">
                  <div class="checkbox"></div>
                  {{c.name}}
                  <div class="ciAction">
                    <div class="edit" v-on:click.stop="editCategory(index, c)"></div>
                    <div class="delete" v-on:click.stop="deleteCategory(index, c)"></div>
                  </div>
                </div>
                <div class="ciItem addCategory" v-on:click="addCategory">
                  <span>+</span> Add new category
                </div>
              </div>
            </div>
          </div>

          <button :class="{btn: true, btnPrimary: true, loading: loading}"
            v-on:click="save('published')">
            <span v-if="loading">Saving...</span>
            <span v-else>Publish</span>
          </button>
          <div class="btnConfig" v-if="!loading">
            <div class="theBtn" v-on:click="openConfig"></div>
            <div class="configOverlay" v-if="configOpen"
              v-on:click="configOpen = false"></div>
            <div class="configContent" v-if="configOpen">
              <div class="configItem">
                <h4>Article Info</h4>
                <div class="ciItem">
                  Status
                  <span>Draft</span>
                </div>
                <div class="ciItem">
                  Author
                  <span>{{$session.get('name')}}</span>
                </div>
                <div class="ciItem">
                  Category
                  <span v-if="selectedCategory.length > 1">
                    {{selectedCategory.length}} categories</span>
                  <span v-else-if="selectedCategory.length > 0">
                    {{selectedCategory[0].name}}</span>
                  <span v-else>Uncategorized</span>
                </div>
                <div class="ciItem">
                  Editor Type
                  <span class="editorTypeSelector"
                    v-on:click="showEditorTypeSelector = true"
                    v-if="editorType === 'default'">Default</span>
                  <span class="editorTypeSelector"
                    v-on:click="showEditorTypeSelector = true"
                    v-else-if="editorType === 'html'">HTML</span>
                  <span class="editorTypeSelector"
                    v-on:click="showEditorTypeSelector = true"
                    v-else>Html With Preview</span>
                  <div class="editorTypeSelectorOverlay"
                    v-if="showEditorTypeSelector"
                    v-on:click="showEditorTypeSelector = false"></div>
                  <div class="editorTypeSelectorCnt" v-if="showEditorTypeSelector">
                    <li v-on:click="selectEditorType('default')">Default</li>
                    <li v-on:click="selectEditorType('html')">Html</li>
                    <li v-on:click="selectEditorType('withPreview')">Html With Preview</li>
                  </div>
                </div>
              </div>
              <div class="configItem">
                <h4>Keywords</h4>
                <p>Add keywords in field below, separate by comma.</p>
                <textarea rows="3" class="field" v-model="form.keywords.model"
                  placeholder="Keywords..." v-on:input="save('draft')"></textarea>
              </div>
              <div class="configItem">
                <h4>Thumbnail Image</h4>
                <p>Select one image to be dispayed as article thumbnail.</p>
                <div class="thumbImgCnt">
                  <div :class="{thumbImg: true, selected: selectedThumb
                    && media.id === selectedThumb.id}"
                    v-for="(media, index) in allMedia" :key="index"
                    :style="{'background-image': `url(${media.imageSm})`}"
                    v-on:click="selectedThumb = media; save('draft');"/>
                  <div :class="{thumbImg: true, selected: selectedThumb
                    && customThumb.id === selectedThumb.id}"
                    :style="{'background-image': `url(${customThumb.imageSm})`}"
                    v-on:click="addCustomThumb" v-if="customThumb"/>
                  <div :class="{thumbImg: true, addCustomThumb: true}"
                    v-on:click="addCustomThumb" v-else></div>
                </div>
              </div>
            </div>
          </div>
          <div :class="{draftSaved: true, loading: (draftStatus == 'loading')}"
            v-if="draftStatus">
            <span>Saved</span>
            <div class="loadingImg">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                <g transform="translate(20 50)">
                  <circle cx="0" cy="0" r="6" fill="#b2d1ff" transform="scale(0.97694 0.97694)">
                    <animateTransform attributeName="transform" type="scale" begin="-0.375s"
                      calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                      keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  </circle>
                </g><g transform="translate(40 50)">
                  <circle cx="0" cy="0" r="6" fill="#72a7f5" transform="scale(0.918245 0.918245)">
                    <animateTransform attributeName="transform" type="scale" begin="-0.25s"
                      calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                      keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  </circle>
                </g><g transform="translate(60 50)">
                  <circle cx="0" cy="0" r="6" fill="#2e77e4" transform="scale(0.618706 0.618706)">
                    <animateTransform attributeName="transform" type="scale" begin="-0.125s"
                      calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                      keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  </circle>
                </g><g transform="translate(80 50)">
                  <circle cx="0" cy="0" r="6" fill="#0057d8" transform="scale(0.269344 0.269344)">
                    <animateTransform attributeName="transform" type="scale" begin="0s"
                      calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0"
                      keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                  </circle>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Confirmation ref="confirmDialog"/>
    <Snackbar ref="snackbar"/>
    <MediaInputer ref="mediaInputer"/>
    <MediaSelector ref="mediaSelector"/>
    <VariantEditor ref="variantEditor"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

import { PrismEditor } from 'vue-prism-editor';
import 'vue-prism-editor/dist/prismeditor.min.css';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import 'prismjs/themes/prism-tomorrow.css';

import Editor from '@/components/Editor.vue';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import MediaInputer from '@/components/MediaInputer.vue';
import MediaSelector from '@/components/MediaSelector.vue';
import VariantEditor from '@/components/VariantEditor.vue';

export default {
  name: 'editor',
  components: {
    Editor,
    Confirmation,
    Snackbar,
    MediaInputer,
    MediaSelector,
    PrismEditor,
    VariantEditor,
  },
  data() {
    return {
      deleteConfirmation: false,
      deleteTitle: '',
      deleteDesc: '',
      getingData: false,
      getingData2: true,
      loading: false,
      notFound: false,
      parent: null,
      editData: null,
      titleMinHeight: 'auto',
      openMediaSelector: false,
      draftStatus: null,
      configOpen: false,
      selectedVariantItem: null,
      editorType: 'default',
      form: {
        title: { model: '', error: null },
        content: { model: '' },
        keywords: { model: '' },
        buttonUrl: { model: '' },
      },
      content: '',
      theContent: '',
      buttonUrl: '',
      images: [],
      selectedThumb: null,
      categories: [],
      selectedCategory: [],
      openCategorySelector: false,
      allMedia: [],
      variant: null,
      showVariantOptions: false,
      showVaItemOptions: null,
      showEditorTypeSelector: false,
      t: {
        dates: { active: false, data: [] },
        months: {
          active: false,
          data: ['January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'],
        },
        years: {
          active: false,
          data: ['2018', '2019', '2020', '2021'],
        },
        hours: { active: false, data: [] },
        minutes: { active: false, data: [] },
        ampm: { active: false, data: ['am', 'pm'] },
      },
      variantTimer: null,
      customThumb: null,
      canScroll: true,

      /**
       * Publish time
       *
       */
      pt: new Date(),
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
    addCustomThumb() {
      this.$refs.mediaSelector.open({}, (b, media) => {
        if (!b) return;
        this.customThumb = media;
        this.selectedThumb = media;
      });
    },
    getHours() {
      return this.pt.getHours() < 9 ? `0${this.pt.getHours()}` : this.pt.getHours();
    },
    getMinutes() {
      return this.pt.getMinutes() < 9 ? `0${this.pt.getMinutes()}` : this.pt.getMinutes();
    },
    highlighter(code) {
      return highlight(code, languages.js);
    },
    selectPT(type, value) {
      switch (type) {
        case 'date':
          this.pt.setDate(value);
          this.t.dates.active = false;
          break;

        case 'month':
          this.pt.setMonth(value);
          this.t.months.active = false;
          break;

        case 'year':
          this.pt.setFullYear(value);
          this.t.years.active = false;
          break;

        case 'hour':
          this.pt.setHours(Number(value));
          this.t.hours.active = false;
          break;

        case 'minute':
          this.pt.setMinutes(Number(value));
          this.t.minutes.active = false;
          break;

        default:
          break;
      }
    },
    selectEditorType(et) {
      this.showEditorTypeSelector = false;
      this.editorType = et;
      if (et === 'default') {
        this.content = '';
        setTimeout(() => {
          this.content = this.form.content.model;
        });
      }
    },
    deleteVariant() {
      this.showVariantOptions = false;
      this.$refs.confirmDialog.open({
        title: 'Delete Variant',
        desc: 'Are you sure you want variant for this product?',
        action: 'Delete',
      }, (b) => {
        if (!b) return;
        this.variant = null;
        this.save('draft');
        this.images = this.editData.images || [];
        this.form.buttonUrl.model = this.editData.buy_uri;
        this.form.content.model = this.editData.content;
        setTimeout(() => {
          this.content = this.editData.content;
        });
      });
    },
    editVariant() {
      this.showVariantOptions = false;
      this.$refs.mediaInputer.open({
        title: 'Variant Name',
        placeholder: 'Example: Color, Size, etc...',
        action: 'Save Changes',
        model: this.variant.name,
      }, (b, v) => {
        if (!b || !v || v === '') return;
        this.variant.name = v;
        this.save('draft');
      });
    },
    addVariant() {
      this.$refs.mediaInputer.open({
        title: 'Variant Name',
        placeholder: 'Example: Color, Size, etc...',
        action: 'Add Variant',
      }, (b, v) => {
        if (!b || !v || v === '') return;
        this.variant = {
          name: v,
          items: [],
        };
        this.save('draft');
      });
    },
    editVariantItem(i, item) {
      this.showVaItemOptions = false;
      if (i === 0) {
        this.$refs.mediaInputer.open({
          title: 'Edit Variant Item',
          placeholder: `${this.variant.name}...`,
          action: 'Save',
          model: item.name,
        }, (b, v) => {
          if (!b || !v || v === '') return;
          this.variant.items[i].name = v;
          this.doSave('draft', (res) => {
            if (!this.editData) this.editData = res.data;
            this.$http.post(this.$config.uri(`article/${this.editData.id}/variant`), {
              id: item.id,
              name: v,
              content: item.content,
              buy_uri: item.buy_uri,
              isDefault: item.isDefault,
            }).then((r) => {});
          });
        });
      } else {
        this.doSave('draft', (res) => {
          this.canScroll = false;
          this.$refs.variantEditor.open(this.editData, item, (b, newVariant) => {
            this.canScroll = true;
            if (!b) return;
            this.variant.items[i].name = newVariant.name;
            this.variant.items[i].content = newVariant.content;
            this.variant.items[i].buy_uri = newVariant.buy_uri;
          });
        });
      }
    },
    deleteVariantItem(i, item) {
      this.doSave('draft', (res) => {
        this.showVaItemOptions = false;
        this.$refs.confirmDialog.open({
          title: 'Delete Variant Item',
          desc: `Are you sure you want to delete ${item.name} from variant list?`,
          action: 'Delete',
        }, (b) => {
          if (!b) return;
          this.variant.items.splice(i, 1);
          const deleteUri = `article/${this.editData.id}/variant/${item.id}/delete`;
          this.$http.get(this.$config.uri(deleteUri)).then((r) => {
            if (r.data.status !== 200) {
              // Display error
              return;
            }
            this.$refs.snackbar.open({ content: 'Variant item has been deleted.' });
          });
        });
      });
    },
    addVariantItem() {
      if (this.variant.items.length > 0) {
        this.doSave('draft', (res) => {
          this.canScroll = false;
          this.$refs.variantEditor.open(this.editData, null, (b, newVariant) => {
            this.canScroll = true;
            if (!b) return;
            this.variant.items.push(newVariant);
          });
        });
      } else {
        this.$refs.mediaInputer.open({
          title: `Add ${this.variant.name}`,
          placeholder: `${this.variant.name}...`,
          action: 'Save',
        }, (b, v) => {
          if (!b || !v || v === '') return;
          const newVariant = {
            name: v,
            content: '',
            buy_uri: '',
            isDefault: 0,
          };
          this.variant.items.push(newVariant);
          if (this.variant.items.length === 1) {
            [this.selectedVariantItem] = this.variant.items;
            newVariant.isDefault = 1;
          }
          this.doSave('draft', (res) => {
            if (!this.editData) this.editData = res.data;
            this.$http.post(this.$config.uri(`article/${this.editData.id}/variant`), {
              name: v,
              content: '',
              buy_uri: '',
              isDefault: newVariant.isDefault,
            }).then((r) => {
              newVariant.id = r.data.id;
            });
          });
        });
      }
    },
    buttonUrlChanged() {
      this.buttonUrl = this.form.buttonUrl.model;
      this.save('draft');
    },
    contentChanged() {
      this.theContent = this.form.content.model;
      this.save('draft');
    },
    addImg() {
      this.$refs.mediaSelector.open({
      }, (b, media) => {
        if (!b) return;
        const img = { media };
        this.images.push(img);
        this.doSave('draft', (res) => {
          if (!this.editData) this.editData = res.data;
          this.$http.post(this.$config.uri(`article/${this.editData.id}/image`), {
            mediaId: media.id,
          }).then((r) => {
            img.id = r.data.data.id;
            const imgTmp = this.images;
            this.images = [];
            setTimeout(() => {
              this.images = imgTmp;
            });
          });
        });
      });
    },
    deleteImg(i, img) {
      this.$refs.confirmDialog.open({
        title: 'Delete Image',
        desc: 'Are you sure you want to delete this image?',
        action: 'Delete',
      }, (b) => {
        if (!b) return;
        this.images.splice(i, 1);
        this.$http.get(this.$config.uri(`article/image/${img.id}/delete`)).then((r) => {
          if (r.data.status !== 200) {
            // Display error
            return;
          }
          this.$refs.snackbar.open({ content: 'Image has been deleted.' });
        });
      });
    },
    editImg(i, img) {
      this.$refs.mediaSelector.open({
      }, (b, media) => {
        if (!b) return;
        this.images[i].media = media;
        this.doSave('draft', (res) => {
          if (!this.editData) this.editData = res.data;
          this.$http.post(this.$config.uri(`article/${this.editData.id}/image`), {
            id: img.id,
            mediaId: media.id,
          }).then((r) => {});
        });
      });
    },
    selectCategory(i, c) {
      this.categories[i].selected = !c.selected;
      this.$http.post(this.$config.uri(`article/${this.editData.id}/category/${c.id}`), {
        selected: this.categories[i].selected,
      }).then((r) => {});
      this.categoryChanged();
    },
    categoryChanged() {
      this.selectedCategory = [];
      // eslint-disable-next-line
      for (const item of this.categories) {
        if (item.selected) this.selectedCategory.push(item);
      }
    },
    editCategory(i, c) {
      this.$refs.mediaInputer.open({
        title: 'Category Name',
        placeholder: 'Category name...',
        action: 'Save Changes',
        model: c.name,
      }, (b, v) => {
        if (!b || !v || v === '') return;
        this.categories[i].name = v;
        this.$http.post(this.$config.uri('article/category'), {
          id: c.id,
          name: v,
          parent: this.parent.id,
        }).then((r) => {});
      });
    },
    addCategory() {
      this.$refs.mediaInputer.open({
        title: 'Category Name',
        placeholder: 'Category name...',
        action: 'Add Category',
      }, (b, v) => {
        if (!b || !v || v === '') return;
        this.$http.post(this.$config.uri('article/category'), {
          name: v,
          parent: this.parent.id,
        }).then((r) => {
          this.categories.push(r.data.data);
        });
      });
    },
    deleteCategory(i, c) {
      this.$refs.confirmDialog.open({
        title: 'Delete Category',
        desc: `Are you sure you want to ${c.name} from category list?`,
        action: 'Delete',
      }, (b) => {
        if (!b) return;
        this.categories.splice(i, 1);
        this.categoryChanged();
        this.$http.get(this.$config.uri(`article/category/${c.id}/delete`)).then((r) => {
          if (r.data.status !== 200) {
            // Display error
            return;
          }
          this.$refs.snackbar.open({ content: 'Category has been deleted.' });
        });
      });
    },
    titleChanged() {
      this.form.title.error = null;
      this.titleMinHeight = `${this.$refs.title.scrollHeight}px`;
      if (this.form.title.model === '') {
        this.titleMinHeight = 'auto';
      }
      this.save('draft');
    },
    openConfig() {
      this.configOpen = true;
      this.allMedia = [];
      // eslint-disable-next-line
      for (const item of this.images) {
        this.allMedia.push(item.media);
      }
      let allMediaEl = [];
      if (this.$refs.editor && this.$refs.editor.$el) {
        allMediaEl = this.$refs.editor.$el.querySelectorAll('img.theMedia');
      }
      // eslint-disable-next-line
      for (const item of allMediaEl) {
        this.allMedia.push({
          id: parseInt(item.getAttribute('mediaid'), 10),
          imageSm: item.src,
        });
      }
      if (!this.selectedThumb && this.allMedia && this.allMedia.length > 0) {
        [this.selectedThumb] = this.allMedia;
      }
    },
    save(status) {
      if (status === 'draft') {
        clearTimeout(this.draftTimer);
        this.draftTimer = setTimeout(() => {
          this.draftStatus = 'loading';
          this.doSave(status, (res) => {
            this.draftStatus = 'saved';
            if (res.status !== 200) {
              // Display error
              return;
            }
            this.editData = res.data;
            const newPath = `${process.env.BASE_URL}article/editor?`
              + `id=${this.editData.id}&parent=${this.parent.slug}`;
            window.history.replaceState(null, null, newPath);
            setTimeout(() => {
              this.draftStatus = null;
            }, 1800);
          });
        }, 400);
      } else {
        this.loading = true;
        this.doSave(status, (res) => {
          this.loading = false;
          if (res.status !== 200) {
            // Display error
            return;
          }
          this.editData = res.data;
          if (this.parent && this.parent.slug === 'bodykey') {
            this.$router.push('/bodykey/landing-page?tab=thumb');
            return;
          }
          this.$router.push(`/article/${this.parent.slug}`);
        });
      }
    },
    doSave(status, next) {
      const formData = {
        status,
        title: this.form.title.model,
        content: this.theContent,
        publishDate: this.pt.getTime() / 1000,
        tags: this.form.keywords.model,
        buyUri: this.buttonUrl,
      };
      formData.variant = (this.variant) ? this.variant.name : null;
      if ((!formData.title || formData.title === '') && status === 'published') {
        this.form.title.error = true;
        return;
      }
      if (this.editData) {
        formData.id = this.editData.id;
      }
      if (this.selectedThumb) {
        formData.thumb = this.selectedThumb.id;
      } else {
        this.allMedia = [];
        // eslint-disable-next-line
        for (const item of this.images) {
          this.allMedia.push(item.media);
        }
        let allMediaEl = [];
        if (this.$refs.editor && this.$refs.editor.$el) {
          allMediaEl = this.$refs.editor.$el.querySelectorAll('img.theMedia');
        }
        // eslint-disable-next-line
        for (const item of allMediaEl) {
          this.allMedia.push({
            id: parseInt(item.getAttribute('mediaid'), 10),
            imageSm: item.src,
          });
        }
        if (!this.selectedThumb && this.allMedia && this.allMedia.length > 0) {
          [this.selectedThumb] = this.allMedia;
          formData.thumb = this.selectedThumb.id;
        } else {
          formData.thumb = 0;
        }
      }

      const saveUri = `article/save?parent=${this.parent.id}`;
      this.$http.post(this.$config.uri(saveUri), formData).then((response) => {
        if (next) next(response.data);
      });
    },
    getData() {
      const { id } = this.$route.query;
      if (id) {
        this.getingData = true;
        const detailUri = `article?id=${id}`;
        this.$http.get(this.$config.uri(detailUri)).then((response) => {
          this.getingData = false;
          if (response.data.status !== 200) {
            // Display error
            this.notFound = true;
            return;
          }
          this.editData = response.data.data;

          if (this.editData.featured_image) {
            this.selectedThumb = { id: this.editData.featured_image };
          }

          this.images = this.editData.images || [];
          this.variant = this.editData.variant || null;
          if (this.variant && this.variant.items && this.variant.items.length > 0) {
            [this.selectedVariantItem] = this.variant.items;
          }
          this.selectedCategory = this.editData.categories;

          this.form.title.model = this.editData.title;
          this.form.content.model = this.editData.content;
          this.form.keywords.model = this.editData.tags;
          this.form.buttonUrl.model = this.editData.buy_uri;
          this.buttonUrl = this.editData.buy_uri;
          this.theContent = this.editData.content;
          setTimeout(() => {
            this.content = this.editData.content;
          });
          this.pt = new Date(this.editData.publish_date * 1000);
          setTimeout(() => {
            this.titleChanged();
          });

          this.doSave('draft', (res) => {
            this.draftStatus = 'saved';
            if (res.status !== 200) {
              // Display error
              return;
            }
            this.editData = res.data;
            const newPath = `${process.env.BASE_URL}article/editor?`
              + `id=${this.editData.id}&parent=${this.parent.slug}`;
            window.history.replaceState(null, null, newPath);
            if (parseInt(this.editData.id, 10) !== parseInt(id, 10)) {
              window.location.reload();
            } else {
              this.getingData2 = false;
            }
          });
        });
      } else {
        this.getingData2 = false;
      }
    },
  },
  mounted() {
    this.chCGB(true);
    const { parent } = this.$route.query;
    this.contentFor = 'article';
    this.$http.get(this.$config.uri(`article/parent/${parent}`)).then((response) => {
      this.parent = response.data.data;
      this.chTitle(`Content - ${this.parent.name}`);
      this.$http.get(this.$config.uri(`article/${this.parent.id}/categories`
        + `?postId=${this.$route.query.id}`)).then((r) => {
        this.categories = (r.data && r.data.status === 200) ? r.data.data : [];
      });
      this.getData();
    });

    let i = 0;
    for (i = 1; i < 32; i += 1) {
      this.t.dates.data.push(i);
    }
    for (i = 0; i < 24; i += 1) {
      const i2 = (i < 10) ? `0${i.toString()}` : i.toString();
      this.t.hours.data.push(i2);
    }
    for (i = 0; i < 60; i += 1) {
      const i2 = (i < 10) ? `0${i.toString()}` : i.toString();
      this.t.minutes.data.push(i2);
    }
  },
};
</script>

<style lang="scss">
  .prism-editor__textarea:focus {
    outline: none;
  }
  .editorPreview{
    img{
      width: 100%;
      height: auto;
    }
    p{
      margin: 0 0 20px;
    }
    input{
      display: none;
    }
    .img-cnf-cnt{
      display: none;
    }
    .img-container{
      margin: 0 0 20px;
    }
  }
</style>
<style scoped lang="scss">
  #home.content{
    height: calc(100vh - 103px);
    overflow-y: auto;
    &.noScroll{
      overflow: hidden;
    }
  }
  .editorCnt{
    &.withPreview{
      display: flex;
      margin: -30px -30px 0;
      .editorL{
        width: 56%;
        box-sizing: border-box;
      }
      .editorR{
        border-left: #999 4px solid;
        width: 44%;
        .htmlEditorHeader{
          background-color: #eee;
          padding-left: 20px;
        }
        .editorPreview{
          padding: 10px 20px;
        }
      }
      .htmlEditorHeader{
        margin-top: 0;
      }
    }
    .htmlEditorHeader{
      background-color: #ccc;
      padding: 8px 40px;
      margin-top: 10px;
    }
    .htmlEditor{
      background: #2d2d2d;
      color: #ccc;
      font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
      font-size: 14px;
      line-height: 1.5;
      padding: 10px 16px;
      padding-left: 40px;
      position: relative;
      box-sizing: border-box;
      &:before{
        position: absolute;
        content: "";
        left: 0; top: 0; bottom: 0;
        width: 20px;
        background-color: #3e3e3e;
      }
    }
  }
  .productVariants{
    position: fixed;
    z-index: 4;
    background-color: #fff;
    left: 300px; right: 0; top: 49px;
    display: flex;
    align-items: center;
    border-bottom: #eee 1px solid;
    padding: 0 30px;
    .variantConfig{
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: absolute;
      right: 22px; top: 5px;
      background-image: url(../assets/settings.png);
      background-size: 16px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .5;
      transition: all .3s ease;
      cursor: pointer;
      &:hover{
        background-color: #eee;
        opacity: .8;
      }
    }
    h4{
      margin: 0;
      margin-right: 10px;
      font-weight: normal;
      color: #767676;
      height: 100%;
      font-size: 16px;
      padding: 10px 0;
      padding-right: 30px;
      border-right: #eee 1px solid;
    }
    .variantOverlay{
      position: fixed;
      top: 0; right: 0; left: 0; bottom: 0;
      z-index: 4;
    }
    .variantOptions{
      position: absolute;
      right: 20px; top: 100%;
      background-color: #fff;
      z-index: 999;
      padding: 10px 0;
      margin-top: -8px;
      border: #eee 1px solid;
      border-radius: 5px;
      box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.2);
      width: 200px;
      cursor: default;
      li{
        color: #444;
        list-style: none;
        padding: 10px 20px;
        cursor: pointer;
        &:hover{
          background-color: #f5f5fe;
        }
      }
    }
    .variantItem{
      padding: 10px 20px;
      position: relative;
      font-weight: 600;
      color: #767676;
      font-size: 16px;
      cursor: pointer;
      padding-right: 42px;
      .vaItemOverlay{
        position: fixed;
        top: 0; right: 0; left: 0; bottom: 0;
        z-index: 3;
      }
      .vaItemOptions{
        position: absolute;
        left: 6px; top: 100%;
        background-color: #fff;
        z-index: 999;
        padding: 10px 0;
        margin-top: -8px;
        border: #eee 1px solid;
        border-radius: 5px;
        box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.2);
        width: 150px;
        cursor: default;
        li{
          color: #444;
          list-style: none;
          padding: 10px 20px;
          cursor: pointer;
          font-weight: normal;
          &:hover{
            background-color: #f5f5fe;
          }
        }
      }
      .more{
        content: "";
        width: 24px;
        height: 24px;
        position: absolute;
        right: 10px; top: 8px;
        border-radius: 50%;
        background-image: url(../assets/down-arrow.png);
        background-size: 10px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .6;
        cursor: pointer;
        &:hover{
          background-color: #ddd;
          opacity: .8;
        }
      }
      &:before{
        content: "";
        position: absolute;
        left: 0; right: 0; bottom: 0;
        height: 3px;
        border-radius: 5px 5px 0 0;
      }
      &:hover{
        background-color: #eee;
        color: #444;
        &:before{
          background-color: #999;
        }
      }
      &.active{
        color: #0057d8;
        &:before{
          background-color: #0057d8;
        }
      }
      &.addVariantItem{
        border: #ccc 1px solid;
        border-radius: 50px;
        padding: 4px 16px;
        padding-left: 30px;
        margin-left: 16px;
        font-weight: normal;
        &:before{
          display: none;
        }
        .more{
          display: none;
        }
        span{
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          left: 4px;
          top: 3px;
          border-radius: 50%;
          box-sizing: border-box;
          border: #999 1px solid;
          font-size: 18px;
          transition: all .3s ease;
        }
      }
    }
  }
  .sectionTitle{
    margin: 0 5px 10px;
    text-transform: uppercase;
    font-weight: 600;
    color: #767676;
    font-size: 13px;
    &.sectionTitleEditor{
      margin: 0 5px;
    }
  }
  .buyButtonCnt{
    margin: 20px 0 40px;
  }
  .aticlesImages{
    display: flex;
    flex-wrap: wrap;
    .articleImg{
      width: 160px; height: 160px;
      border-radius: 5px;
      background-color: #f5f5f5;
      text-align: center;
      color: #767676;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all .3s ease;
      margin: 0 10px 16px 0;
      box-shadow: 2px 2px 2px rgba(0,0,0,.1);
      position: relative;
      overflow: hidden;
      .theImg{
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        position: absolute;
        top: 0; right: 0; bottom: 0; left: 0;
        .imgAction{
          position: absolute;
          top: 8px; right: 8px;
          display: flex;
          .delete, .edit{
            width: 30px; height: 30px;
            background-color: #fff;
            border-radius: 50%;
            margin-left: 6px;
            box-shadow: 2px 2px 2px rgba(0,0,0,.1);
            background-size: 15px auto;
            background-position: center;
            background-repeat: no-repeat;
            cursor: pointer;
            &:hover{
              background-color: #eee;
            }
          }
          .delete{
            background-image: url(../assets/delete.png);
          }
          .edit{
            background-image: url(../assets/edit-black.png);
          }
        }
      }
      &.addImg{
        cursor: pointer;
        &:hover{
          background-color: #ddd;
          color: #444;
          .addImg{
            img{
              opacity: .7;
            }
          }
        }
      }
      .addImg{
        font-size: 13px;
        padding: 0 10px;
        line-height: 1.2;
        img{
        transition: all .3s ease;
          display: block;
          margin: 0 auto 6px;
          width: 30px;
          height: auto;
          opacity: .4;
        }
      }
    }
  }
  .getingData{
    background-color: #fff;
    z-index: 999;
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-image: url(../assets/loading-2.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 60px auto;
  }
  .notFound{
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    img{
      height: 340px;
      margin-bottom: 40px;
    }
    h4{
      font-size: 30px;
      font-weight: normal;
      margin: 0 0 10px;
    }
    p{
      max-width: 600px;
      color: #767676;
      font-size: 17px;
    }
  }
  .articleCnt{
    max-width: 700px;
    margin: 0 auto;
    padding: 20px 0 40px;
    // min-height: 400px;
    position: relative;
    z-index: 3;
    &.hasVariant{
      padding-top: 60px;
    }
    .addVariant{
      padding: 6px 10px;
      border: #ccc 1px solid;
      display: inline-block;
      cursor: pointer;
      border-radius: 50px;
      color: #767676;
      position: relative;
      padding-left: 36px;
      transition: all .3s ease;
      span{
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 9px;
        top: 6px;
        border-radius: 50%;
        box-sizing: border-box;
        border: #999 1px solid;
        font-size: 18px;
        transition: all .3s ease;
      }
      &:hover{
        color: #444;
        border-color: #999;
        background-color: #f5f5f5;
        span{
          border-color: #767676;
        }
      }
    }
    .articleTitle{
      width: 100%;
      box-sizing: border-box;
      border: none;
      padding: 10px 0;
      outline: 0;
      font-size: 40px;
      font-weight: bold;
      resize: none;
    }
    .titleError{
      color: red;
      border-top: red 3px solid;
      margin: -4px 0 16px;
    }
  }

  .thumbImgCnt{
    display: flex;
    flex-wrap: wrap;
    padding-top: 10px;
    margin-bottom: -6px;
    .thumbImg{
      width: 60px; height: 60px;
      border-radius: 50px;
      border: #fff 3px solid;
      background-size: cover;
      transition: all .16s ease;
      margin: 0 10px 6px -3px;
      cursor: pointer;
      &.addCustomThumb{
        background-color: #aaa;
        background-image: url(../assets/photo-black.png);
        background-size: 26px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .4;
        &:hover{
          opacity: .6;
        }
      }
      &:hover{
        border-color: #999;
      }
      &.selected{
        border-color: #0057d8;
      }
    }
  }

  .attachmentCnt{
    padding-top: 20px;
    margin-top: 20px;
    border-top: #eee 1px dashed;
    .aTitle{
      font-size: 20px;
      margin: 0 7px 6px;
    }
    .attachmentItem{
      position: relative;
      min-height: 46px;
      padding: 10px;
      padding-left: 68px;
      background-color: #f5f5f5;
      border-radius: 5px;
      border: #ddd 1px solid;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      .attachmentIcon{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 46px; height: 46px;
        border-radius: 5px;
        background-color: #0057d8;
        font-size: 13px;
        color: #fff;
        font-weight: 600;
        text-transform: uppercase;
        position: absolute;
        left: 10px; top: 10px;
      }
      .aIcon{
        position: absolute;
        width: 30px; height: 30px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 12px auto;
        background-image: url(../assets/close.png);
        border-radius: 50%;
        top: 50%; right: 10px;
        margin-top: -15px;
        transition: background-color .3s ease;
        cursor: pointer;
        opacity: .7;
        &:hover{
          background-color: #ddd;
        }
        &.download{
          right: 82px;
          background-image: url(../assets/download-o.png);
          background-size: 14px auto;
          opacity: 1;
        }
        &.edit{
          right: 46px;
          background-image: url(../assets/edit-black.png);
          background-size: 14px auto;
          opacity: 1;
        }
      }
      h4{
        margin: 0;
        font-size: 18px;
        font-weight: 500;
      }
      p{
        margin: 0;
        color: #767676;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      &.uploading{
        .attachmentIcon{
          background-color: #ddd;
          color: #eee;
          &:before{
            position: absolute;
            content: "";
            left: 0; top: 0; right: 0; bottom: 0;
            background-image: url(../assets/loading-2.svg);
            background-size: 24px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }

  .authorInfo{
    position: relative;
    padding-top: 8px;
    padding-left: 50px;
    padding-bottom: 16px;
    .authorImg{
      position: absolute;
      left: 0;
      top: 8px;
      width: 39px;
      height: 39px;
      background-color: #0e5dd2;
      // background-image: url(../assets/user.png);
      background-size: cover;
      background-position: center;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      text-transform: uppercase;
      line-height: 0;
      &.hasPhoto{
        span{
          display: none;
        }
      }
    }
    h4{
      margin: 0;
      font-size: 17px;
    }
    .publishTime{
      margin: 0;
      font-size: 14px;
      span{
        position: relative;
        color: #0057d8;
        cursor: pointer;
        i{
          font-style: normal;
        }
        .overlay{
          display: none;
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          z-index: 3;
          cursor: default;
        }
        .timeSelector{
          display: none;
          position: absolute;
          top: 100%;
          left: -10px;
          margin-top: 4px;
          background-color: #fff;
          z-index: 999;
          border: #ccc 1px solid;
          border-radius: 4px;
          padding: 5px 0;
          max-height: 300px;
          overflow-y: auto;
          z-index: 4;
          li{
            list-style: none;
            padding: 5px 20px;
            // min-width: 30px;
            // text-align: center;
            color: #444;
          }
          li:hover{
            background-color: #eee;
          }
        }
        .overlay.active{
          display: block;
        }
        .timeSelector.active{
          display: block;
        }
      }
    }
  }

  .formAction{
    position: fixed;
    bottom: 0;
    left: 300px;
    right: 0;
    background-color: #fff;
    // box-shadow: 0 0 6px rgba(0,0,0,.1);
    border-top: #ddd 1px solid;
    padding: 7px 0;
    text-align: right;
    z-index: 4;
    .formActionCnt{
      position: relative;
      max-width: 700px;
      margin: 0 auto;
      .categoryCnt{
        float: left;
        margin-right: 4px;
        position: relative;
        .configOverlay{
          position: fixed;
          left: 0; right: 0; bottom: 0; top: 0;
          z-index: 8;
        }
        .configContent{
          position: absolute;
          bottom: 100%;
          min-width: 240px;
          width: auto;
          padding: 20px;
          padding-bottom: 0;
          left: 0px;
          margin-bottom: 10px;
          box-shadow: 1px 1px 2px rgba(0,0,0,.1);
          background-color: #fff;
          text-align: left;
          border: #ccc 1px solid;
          z-index: 9;
          border-radius: 7px;
          &:before{
            position: absolute;
            content: "";
            left: 50%;
            bottom: -10px;
            margin-left: 16px;
            border-top: #ccc 10px solid;
            border-left: transparent 10px solid;
            border-right: transparent 10px solid;
          }
          &:after{
            position: absolute;
            content: "";
            left: 50%;
            bottom: -8px;
            margin-left: 17px;
            border-top: #fff 9px solid;
            border-left: transparent 9px solid;
            border-right: transparent 9px solid;
          }
          .configItem{
            margin-bottom: 16px;
            h4{
              margin: 0;
              margin-bottom: 6px;
              font-size: 22px;
              font-weight: normal;
            }
            .ciItem{
              margin: 0 -20px;
              padding: 10px 20px;
              padding-left: 54px;
              cursor: pointer;
              color: #444;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-weight: 600;
              position: relative;
              padding-right: 80px;
              .ciAction{
                position: absolute;
                right: 10px; top: 7px;
                opacity: 0;
                display: flex;
                .edit, .delete{
                  width: 26px;
                  height: 26px;
                  margin-left: 2px;
                  border-radius: 50%;
                  background-size: 14px auto;
                  background-position: center;
                  background-repeat: no-repeat;
                  transition: all .3s ease;
                }
                .edit{
                  background-image: url(../assets/edit-black.png);
                  opacity: .6;
                  &:hover{
                    opacity: .8;
                    background-color: #e5e5e5;
                  }
                }
                .delete{
                  background-image: url(../assets/close-thin.png);
                  background-size: 12px auto;
                  opacity: .4;
                  &:hover{
                    opacity: .6;
                    background-color: #ddd;
                  }
                }
              }
              &.addCategory{
                color: #767676;
                span{
                  width: 18px; height: 18px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: absolute;
                  left: 20px; top: 11px;
                  border-radius: 50%;
                  box-sizing: border-box;
                  border: #999 1px solid;
                  font-size: 17px;
                }
                &:hover{
                  color: #444;
                  span{
                    border-color: #767676;
                  }
                }
              }
              .checkbox{
                width: 18px; height: 18px;
                position: absolute;
                top: 11px; left: 20px;
                border-radius: 3px;
                border: #bbb 2px solid;
                box-sizing: border-box;
              }
              &:hover{
                background-color: #f5f5fe;
                .checkbox{
                  border-color: #767676;
                }
                .ciAction{
                  opacity: 1;
                }
              }
              &.selected{
                .checkbox{
                  border-color: #0557d8;
                  background-color: #0557d8;
                  background-image: url(../assets/checked.png);
                  background-size: contain;
                  background-position: center;
                  background-repeat: no-repeat;
                }
              }
            }
          }
        }
        .theBtn{
          color: #767676;
          padding: 4px 10px 6px;
          border-radius: 50px;
          background-color: #f5f5f5;
          margin-top: 6px;
          cursor: pointer;
          &.cl{
            height: 30px;
            box-sizing: border-box;
            padding-left: 4px;
          }
          &:hover{
            background-color: #eee;
          }
          b{
            color: #444;
            max-width: 140px;
            float: right;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            display: inline-block;
            margin-left: 8px;
            &.cl{
              padding-left: 22px;
              position: relative;
              &:before{
                content: "";
                position: absolute;
                left: 0; top: 2px;
                width: 16px; height: 16px;
                background-position: center;
                background-size: contain;
                background-repeat: no-repeat;
                opacity: .7;
              }
              &.preview:before{
                background-image: url(../assets/public.png);
              }
              &.main:before{
                background-image: url(../assets/private.png);
              }
            }
          }
          img{
            height: 14px;
            margin-top: 4px;
            float: right;
            margin-left: 10px;
          }
        }
      }
      .btn{
        margin-left: 10px;
        float: right;
        &.loading{
          background-color: #ccc;
          color: #999;
          cursor: default;
          box-shadow: none;
        }
      }
      .draftSaved{
        position: relative;
        float: right;
        height: 36px;
        width: 60px;
        margin-top: 3px;
        span{
          color: #0057d8;
          font-size: 14px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .loadingImg{
          display: none;
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          svg{
            width: 100%;
            height: 100%;
          }
        }
      }
      .draftSaved.loading{
        span{
          display: none;
        }
        .loadingImg{
          display: block;
        }
      }
      .btnAttachment{
        float: right;
        width: 36px;
        height: 36px;
        position: relative;
        margin-top: 3px;
        .theBtn{
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          border-radius: 50%;
          background-image: url(../assets/attachment.png);
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
          background-color: #fff;
          opacity: .5;
          cursor: pointer;
          &:hover{
            background-color: #eee;
            opacity: 1;
          }
        }
      }
      .btnConfig{
        float: right;
        width: 36px;
        height: 36px;
        padding: 0;
        position: relative;
        margin-top: 3px;
        .theBtn{
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          border-radius: 50%;
          background-image: url(../assets/settings.png);
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
          background-color: #fff;
          opacity: .5;
          cursor: pointer;
          &:hover{
            background-color: #eee;
            opacity: 1;
          }
        }
        .configOverlay{
          position: fixed;
          left: 0; right: 0; bottom: 0; top: 0;
          z-index: 8;
        }
        .configContent{
          position: absolute;
          bottom: 100%;
          width: 240px;
          padding: 20px;
          padding-bottom: 0;
          right: -95px;
          margin-bottom: 10px;
          box-shadow: 1px 1px 2px rgba(0,0,0,.1);
          background-color: #fff;
          text-align: left;
          border: #ccc 1px solid;
          z-index: 9;
          border-radius: 7px;
          &:before{
            position: absolute;
            content: "";
            left: 50%;
            bottom: -10px;
            margin-left: 16px;
            border-top: #ccc 10px solid;
            border-left: transparent 10px solid;
            border-right: transparent 10px solid;
          }
          &:after{
            position: absolute;
            content: "";
            left: 50%;
            bottom: -8px;
            margin-left: 17px;
            border-top: #fff 9px solid;
            border-left: transparent 9px solid;
            border-right: transparent 9px solid;
          }
          .configItem{
            margin-bottom: 25px;
            h4{
              margin: 0;
              margin-bottom: 5px;
              font-size: 22px;
              font-weight: normal;
            }
            p{
              margin: 0;
              font-size: 13px;
            }
            .ciItem{
              font-size: 14px;
              margin-bottom: 12px;
              padding-bottom: 4px;
              border-bottom: #ccc 1px dotted;
              color: #444;
              position: relative;
              .editorTypeSelectorOverlay{
                position: fixed;
                left: 0; right: 0; top: 0; bottom: 0;
                z-index: 2;
              }
              .editorTypeSelectorCnt{
                position: absolute;
                right: 6px; top: 100%;
                background-color: #fff;
                z-index: 999;
                padding: 10px 0;
                margin-top: -4px;
                border: #eee 1px solid;
                border-radius: 5px;
                box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.2);
                width: 150px;
                cursor: default;
                li{
                  color: #444;
                  list-style: none;
                  padding: 10px 20px;
                  cursor: pointer;
                  font-weight: normal;
                  &:hover{
                    background-color: #f5f5fe;
                  }
                }
              }
              .editorTypeSelector{
                padding-right: 16px;
                position: relative;
                cursor: pointer;
                &:hover{
                  color: #444;
                  &:before{
                    opacity: .8;
                  }
                }
                &:before{
                  content: "";
                  position: absolute;
                  right: 0; top: 4px;
                  width: 10px; height: 10px;
                  background-image: url(../assets/down-arrow.png);
                  background-position: center;
                  background-repeat: no-repeat;
                  background-size: contain;
                  opacity: .5;
                }
              }
              span{
                float: right;
                color: #767676;
              }
            }
          }
          .field{
            font-size: 15px;
            padding: 8px 10px;
            margin-top: 10px;
          }
        }
      }
    }
  }
</style>
